var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "9.353448275862092 149.7327586206896 595.5431034482759 325.68103448275866",
    width: 585.04,
    height: 321.68,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.56 415.65C52.46 415.65 44.28 411.41 44.28 406.19C44.28 405.55 44.28 402.4 44.28 396.72L556.19 396.72L556.19 415.65C260.01 415.65 95.47 415.65 62.56 415.65Z",
    id: "cPfCgEQtz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7 179.12C66.65 179.12 62.56 181.84 62.56 185.2C62.56 192.5 62.56 250.89 62.56 258.19C62.56 261.55 66.65 264.27 71.7 264.27C85.41 264.27 195.11 264.27 208.82 264.27C213.87 264.27 217.96 261.55 217.96 258.19C217.96 250.89 217.96 192.5 217.96 185.2C217.96 181.84 213.87 179.12 208.82 179.12C181.4 179.12 85.41 179.12 71.7 179.12Z",
    id: "a6JR9GhjbD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.4 150.73C176.34 150.73 172.26 154.36 172.26 158.84C172.26 168.57 172.26 246.43 172.26 256.16C172.26 260.64 176.34 264.27 181.4 264.27C195.11 264.27 304.8 264.27 318.52 264.27C323.57 264.27 327.66 260.64 327.66 256.16C327.66 246.43 327.66 168.57 327.66 158.84C327.66 154.36 323.57 150.73 318.52 150.73C291.09 150.73 195.11 150.73 181.4 150.73Z",
    id: "h2RSKDa4mS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82 267.34C360.09 265.38 357.64 264.27 355.08 264.27C323.09 264.27 67.13 264.27 35.14 264.27C25.06 264.27 16.85 272.76 16.85 283.19C16.85 290.76 16.85 351.31 16.85 358.88C16.85 379.75 33.25 396.72 53.42 396.72C93.64 396.72 415.41 396.72 455.64 396.72C459.26 396.72 462.55 394.51 464 391.07C465.46 387.64 464.82 383.63 462.38 380.87C442.26 358.16 371.88 278.69 361.82 267.34Z",
    id: "evqJfZpKn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.15 249.43C483.44 207.07 475.28 183.54 473.64 178.83C466.31 161.76 449.92 150.73 431.87 150.73C426.02 150.73 379.21 150.73 373.36 150.73C358.24 150.73 345.94 163.47 345.94 179.12C345.94 195.2 345.94 323.87 345.94 339.96C345.94 371.26 370.54 396.72 400.79 396.72C418.16 396.72 557.1 396.72 574.47 396.72C589.59 396.72 601.9 383.99 601.9 368.34C601.9 360.77 601.9 300.22 601.9 292.65C601.9 274.36 589.27 267.55 571.88 264.27C562.04 262.29 537.47 257.34 498.15 249.43Z",
    id: "b5pk5NtNgY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9 321.03C582.7 321.03 572.03 321.03 569.9 321.03C562.33 321.03 556.19 314.68 556.19 306.84C556.19 306.84 556.19 306.84 556.19 306.84C556.19 299.01 562.33 292.65 569.9 292.65C572.03 292.65 582.7 292.65 601.9 292.65",
    id: "b7p0XAu2R"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 179.12C144.83 179.12 144.83 179.12 144.83 179.12C144.83 230.21 144.83 258.59 144.83 264.27C144.83 264.27 144.83 264.27 144.83 264.27C133.86 264.27 127.77 264.27 126.55 264.27C126.55 264.27 126.55 264.27 126.55 264.27C126.55 213.18 126.55 184.79 126.55 179.12C126.55 179.12 126.55 179.12 126.55 179.12C137.52 179.12 143.61 179.12 144.83 179.12Z",
    id: "b5lB2o9Ds"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.27 179.12C108.27 179.12 108.27 179.12 108.27 179.12C108.27 230.21 108.27 258.59 108.27 264.27C108.27 264.27 108.27 264.27 108.27 264.27C97.3 264.27 91.2 264.27 89.98 264.27C89.98 264.27 89.98 264.27 89.98 264.27C89.98 213.18 89.98 184.79 89.98 179.12C89.98 179.12 89.98 179.12 89.98 179.12C100.95 179.12 107.05 179.12 108.27 179.12Z",
    id: "b1sqZt907C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.28 321.03C44.28 318.2 44.28 295.49 44.28 292.65C44.28 287.43 40.18 283.19 35.14 283.19C33.92 283.19 27.82 283.19 16.85 283.19L16.85 349.42L16.85 349.42C35.14 340.95 44.28 331.49 44.28 321.03Z",
    id: "a4HKivCsM1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 339.96C109.49 339.96 80.84 369.61 80.84 406.19C80.84 442.76 109.49 472.41 144.83 472.41C180.17 472.41 208.82 442.76 208.82 406.19C208.82 369.61 180.17 339.96 144.83 339.96Z",
    id: "c3FtBzbx0y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.83 368.34C124.64 368.34 108.27 385.28 108.27 406.19C108.27 427.09 124.64 444.03 144.83 444.03C165.03 444.03 181.4 427.09 181.4 406.19C181.4 385.28 165.03 368.34 144.83 368.34Z",
    id: "dnmi8xD85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.48 339.96C475.14 339.96 446.49 369.61 446.49 406.19C446.49 442.76 475.14 472.41 510.48 472.41C545.82 472.41 574.47 442.76 574.47 406.19C574.47 369.61 545.82 339.96 510.48 339.96Z",
    id: "c6ggtrivFN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.48 368.34C490.29 368.34 473.92 385.28 473.92 406.19C473.92 427.09 490.29 444.03 510.48 444.03C530.68 444.03 547.05 427.09 547.05 406.19C547.05 385.28 530.68 368.34 510.48 368.34Z",
    id: "iXRUzAxmk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.29 169.66C461.96 169.66 430.32 169.66 373.36 169.66C373.36 206.17 373.36 226.45 373.36 230.51C373.36 240.96 381.55 249.43 391.65 249.43C398.75 249.43 434.25 249.43 498.14 249.43L473.64 178.83C471.45 174.6 469.66 171.54 468.29 169.66Z",
    id: "dBidfTpcT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.9 292.65C601.9 292.65 601.9 292.65 601.9 292.65C601.9 309.68 601.9 319.14 601.9 321.03C601.9 321.03 601.9 321.03 601.9 321.03C590.93 321.03 584.83 321.03 583.61 321.03C583.61 321.03 583.61 321.03 583.61 321.03C583.61 304 583.61 294.54 583.61 292.65C583.61 292.65 583.61 292.65 583.61 292.65C594.58 292.65 600.68 292.65 601.9 292.65Z",
    id: "bNigJgoY0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66 179.12C327.66 179.12 327.66 179.12 327.66 179.12C327.66 190.47 327.66 196.78 327.66 198.04C327.66 198.04 327.66 198.04 327.66 198.04C234.42 198.04 182.62 198.04 172.26 198.04C172.26 198.04 172.26 198.04 172.26 198.04C172.26 186.69 172.26 180.38 172.26 179.12C172.26 179.12 172.26 179.12 172.26 179.12C265.5 179.12 317.3 179.12 327.66 179.12Z",
    id: "aukUkd1fD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66 226.42C327.66 226.42 327.66 226.42 327.66 226.42C327.66 237.78 327.66 244.08 327.66 245.34C327.66 245.34 327.66 245.34 327.66 245.34C234.42 245.34 182.62 245.34 172.26 245.34C172.26 245.34 172.26 245.34 172.26 245.34C172.26 233.99 172.26 227.68 172.26 226.42C172.26 226.42 172.26 226.42 172.26 226.42C265.5 226.42 317.3 226.42 327.66 226.42Z",
    id: "c9K2PLhxD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cPfCgEQtz",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cPfCgEQtz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6JR9GhjbD",
    opacity: 1,
    fill: "#8d8d8d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6JR9GhjbD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2RSKDa4mS",
    opacity: 1,
    fill: "#8d8d8d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2RSKDa4mS",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#evqJfZpKn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#9a1111",
    strokeWidth: 15,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5pk5NtNgY",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5pk5NtNgY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7p0XAu2R",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7p0XAu2R",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5lB2o9Ds",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b5lB2o9Ds",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1sqZt907C",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1sqZt907C",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4HKivCsM1",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#9a1111",
    strokeWidth: 15,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3FtBzbx0y",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3FtBzbx0y",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dnmi8xD85",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dnmi8xD85",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6ggtrivFN",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6ggtrivFN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iXRUzAxmk",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iXRUzAxmk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dBidfTpcT",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dBidfTpcT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bNigJgoY0",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bNigJgoY0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aukUkd1fD",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aukUkd1fD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c9K2PLhxD",
    opacity: 1,
    fill: "#2c2c2c",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c9K2PLhxD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.5f167670d43ac3b8c920f260b76f671c.svg";
export { ForwardRef as ReactComponent };